import instance from "./Request";

export const getProducts = async (branch) => {
  const request = await instance();
  let data = await request.post("/partners/menu/any/44", { branchId: branch }).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const getAdminProducts = async (branchId) => {
  const request = await instance();
  let data = await request.post("/admin/menu-branch", {
    branchId
  }).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const changeActive = async (
  product,
  active,
  platform,
  branch,
  userId,
  entityType
) => {
  const request = await instance();
  let data = await request
    .post("/products/disable", {
      skus: [{ sku: product, platform, active, branch, userId, entityType }],
    })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const getExtras = async (branch) => {
  const request = await instance();
  let data = await request
    .post("/partners/extras/any/44", { branch_id: branch })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const changeExtraActive = async (
  extra,
  active,
  platform,
  branch,
  cat,
  userId
) => {
  const request = await instance();
  let data = await request
    .post("/extras/disable", {
      skus: [{ sku: extra, platform, active, branch, cat, userId }],
    })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const changeSuggested = async (product, active, sectionId, userId) => {
  const request = await instance();
  let data = await request
    .post("/suggested/disable", {
      skus: [{ sku: product, active, section: sectionId, userId }],
    })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};


export const menuCentralAdmin = async (userId) => {
  const request = await instance();
  let data = await request
    .post("/admin/menu-central", { userId })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const menuExtrasAdmin = async (userId) => {
  const request = await instance();
  let data = await request.post("/admin/mc-extras", { userId })
    .catch((error) => {
      return {
        error
      }
    })
  return data
}

export const getCondimentGroups = async () => {
  const request = await instance();
  let data = await request.get("/admin/admin_condiments")
    .catch((error) => ({ error }));
  return data;
};

export const getCondimentsByGroup = async (groupId, branchId) => {
  const request = await instance();
  const url = branchId
    ? `/admin/list_condiments?cat=${groupId}&branchId=${branchId}`
    : `/admin/list_condiments?cat=${groupId}`;
  let data = await request.get(url)
    .catch((error) => ({ error }));
  return data;
};

export const updateCondimentsOrder = async (cat, channelId, orderList, branchId = 0) => {
  const request = await instance();
  let data = await request.post("/admin/update_condiments_order", { cat, channelId, orderList, branchId })
    .catch((error) => ({ error }));
  return data;
};

export const getSetmenuGroups = async () => {
  const request = await instance();
  let data = await request.get("/admin/admin_setmenus")
    .catch((error) => ({ error }));
  return data;
};

export const getSetmenuOptionsByGroup = async (groupId) => {
  const request = await instance();
  const url = `/admin/list_setmenus?cat=${groupId}`;
  let data = await request.get(url)
    .catch((error) => ({ error }));
  return data;
};

export const updateSetmenusOrder = async (cat, channelId, orderList, userId) => {
  const request = await instance();
  let data = await request.post("/admin/update_setmenus_order", { cat, channelId, orderList, userId })
    .catch((error) => ({ error }));
  return data;
};

export const disableSetmenuOptionAdmin = async (userId, sku, mode, cat) => {
  const request = await instance();
  let data = await request.post("/admin/mc-disable-setmenu", { userId, sku, mode, cat })
    .catch((error) => ({ error }));
  return data;
};

export const disableMenuItemAdmin = async (userId, sku, mode) => {
  const request = await instance();
  let data = await request
    .post("/admin/mc-disable-prod", { userId, sku, mode })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const disableMenuItemExtraAdmin = async (userId, sku, mode, cat, branchId) => {
  const request = await instance();
  let data = await request.post("/admin/mc-disable-extra", { userId, sku, mode, cat, branchId })
    .catch((error) => {
      return {
        error
      }
    })
  return data
}

export const importItems = async (whatsync, sku) => {
  const request = await instance()
  let params = { whatsync };
  if (sku) params.sku = sku;

  let data = await request.post("/settings/import-items", params)
    .catch((error) => {
      return {
        error
      }
    })
  return data
}

export const getSyncStatus = async () => {
  const request = await instance();
  let data = await request.get("/settings/sync-status")
    .catch((error) => {
      return {
        error
      }
    });
  return data;
}

export const getAdminCategories = async () => {
  const request = await instance();
  let data = await request.get("/admin/categories")
    .catch((error) => ({ error }));
  return data;
};

export const getCategoryProducts = async (categoryId) => {
  const request = await instance();
  let data = await request.get(`/admin/categories/products?id=${categoryId}`)
    .catch((error) => ({ error }));
  return data;
};

export const updateCategoryImage = async (id, image, type) => {
  const request = await instance();
  let data = await request.post("/admin/categories/update-image", { id, image, type })
    .catch((error) => ({ error }));
  return data;
};

export const toggleCategoryActive = async (id, active, channelId) => {
  const request = await instance();
  let data = await request.post("/admin/categories/toggle-active", { id, active, channelId })
    .catch((error) => ({ error }));
  return data;
};

export const updateCategoryOrder = async (channelId, orderList) => {
  const request = await instance();
  let data = await request.post("/admin/categories/update-order", { channelId, orderList })
    .catch((error) => ({ error }));
  return data;
};

export const updateCategoryName = async (id, name) => {
  const request = await instance();
  let data = await request.post("/admin/categories/update-name", { id, name })
    .catch((error) => ({ error }));
  return data;
};

export const resetCategoryOverride = async (id, channelId) => {
  const request = await instance();
  let data = await request.post("/admin/categories/reset-override", { id, channelId })
    .catch((error) => ({ error }));
  return data;
};

export const resetAllChannelOverrides = async (channelId) => {
  const request = await instance();
  let data = await request.post("/admin/categories/reset-all-overrides", { channelId })
    .catch((error) => ({ error }));
  return data;
};

export const getCustomizableChannels = async () => {
  const request = await instance();
  let data = await request.get("/admin/categories/customizable-channels")
    .catch((error) => ({ error }));
  return data;
};

export const updateCustomizableChannels = async (channelIds) => {
  const request = await instance();
  let data = await request.post("/admin/categories/update-customizable-channels", { channelIds })
    .catch((error) => ({ error }));
  return data;
};

export const toggleIgnoreBranchOverridesApi = async (userId, sku) => {
  const request = await instance();
  let data = await request
    .post("/admin/mc-toggle-ignore-overrides", { userId, sku })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const getProductCustomizableChannels = async (branchId) => {
  const request = await instance();
  let data = await request.post("/admin/mp-customizable-channels", { branchId })
    .catch((error) => ({ error }));
  return data;
};

export const updateProductCustomizableChannels = async (branchId, channelIds) => {
  const request = await instance();
  let data = await request.post("/admin/mp-update-customizable-channels", { branchId, channelIds })
    .catch((error) => ({ error }));
  return data;
};

export const getSetMenuCustomizableChannels = async (groupId) => {
  const request = await instance();
  let data = await request.get(`/admin/setmenus/customizable-channels?cat=${groupId}`)
    .catch((error) => ({ error }));
  return data;
};

export const updateSetMenuCustomizableChannels = async (groupId, channelIds, userId) => {
  const request = await instance();
  let data = await request.post("/admin/setmenus/update-customizable-channels", { cat: groupId, channelIds, userId })
    .catch((error) => ({ error }));
  return data;
};

export const getProductMenu = async (idProduct, branchId = 0) => {
  const request = await instance();
  let data = await request.post(`/products/menu/44/${idProduct}`, { branch_id: branchId })
    .catch((error) => ({ error }));
  return data;
};

export const getProductSteps = async (sku) => {
  const request = await instance();
  let data = await request.get(`/admin/product-steps?sku=${sku}`)
    .catch((error) => ({ error }));
  return data;
};

export const updateProductStepsOrder = async (sku, channelId, orderList, userId) => {
  const request = await instance();
  let data = await request.post("/admin/update-product-steps-order", { sku, channelId, orderList, userId })
    .catch((error) => ({ error }));
  return data;
};

export const getUberBranches = async () => {
  const request = await instance();
  let data = await request.get("/admin/uber-sync/branches")
    .catch((error) => ({ error }));
  return data;
};

export const getUberMenuPreview = async () => {
  const request = await instance();
  let data = await request.get("/admin/uber-sync/preview")
    .catch((error) => ({ error }));
  return data;
};

export const getUberLiveMenu = async () => {
  const request = await instance();
  let data = await request.get("/admin/uber-sync/live-menu")
    .catch((error) => ({ error }));
  return data;
};

export const triggerUberSync = async (branchIds) => {
  const request = await instance();
  let data = await request.post("/admin/uber-sync/sync", { branchIds })
    .catch((error) => ({ error }));
  return data;
};